
import React, { useEffect, useState } from 'react'
import { SearchIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import ActionDropdown from "../../components/ActionDropdown";
import QuickOnlineAccountServices from '../../services/QuickOnlineAccountServices';
import Paginate from '../../utils/Paginate';
import { convert, formatDate } from './../../utils/convertDate';
import DatePicker from 'react-date-picker';



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const stageStyles = {
  Completed: 'bg-green-100 text-green-800',
  'In Progress': 'bg-blue-100 text-blue-800',
  Initiated: 'bg-yellow-100 text-yellow-800',
  Failed: 'bg-red-100 text-red-800',
  Pending: 'bg-amber-100 text-amber-800',
  Submitted: 'bg-blue-100 text-blue-800',
}

export default function OnlineAccountOpening() {
  const [accounts, setAccount] = useState([])
  const [search, setSearch] = useState("")
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0)
  const [nextPage, setNextPage] = useState(false)
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("")
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date()
  })
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const [accountOpeningMedium, setAccountOpeningMedium] = useState("");


  const listAllAccount = async (searchParam, fromParam, toParam, medium) => {
    const account = await QuickOnlineAccountServices.listAccounts(pageIndex, 10, searchParam ?? "", fromParam ?? "", toParam ?? "", medium ?? "");
    if (account && account.data) {
      setAccount([...account.data.result]);
      setPageLength([...account.data.result].length)
      setPageNumber(account.data.totalCount)
      setPageIndex(account.data.pageIndex)
      setPrev(account.data.hasPreviousPage);
      setPage(account.data.totalPages)
      setNextPage(account.data.hasNextPage)
    }
  }

  const searchAccount = async (text) => {
    setSearch(text);
  };

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from)
    setFrom(formValues.from)
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to)
    setToo(convert(toDate));

    listAllAccount(search, convert(newDate), convert(toDate), accountOpeningMedium);
  }

  const handleMedium = async (text) => {
    text = text === "All" ? "" : text;
    setAccountOpeningMedium(text);
    listAllAccount(search, fromm, too, text);
  }

  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event })
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event })
    }
  };

  const handleExport = async () => {
    const resp = await QuickOnlineAccountServices.exportAccounts(search, fromm, too);
    if (resp && resp.data) {
      window.open(resp.data);
    }
  }

  useEffect(() => {
    listAllAccount(search, fromm, too, accountOpeningMedium);
  }, [pageIndex]);

  return (<>
    <Layout title="Online Account Opening" pageTag={'account'} current={'/online/accounts'}>
      <React.Fragment>
        <main>
          <div className='max-w-7xl mx-auto '>
            <div className=''>
              <div className="">
                <div className="mt-5 sm:ml-16 flex justify-end">
                  <button
                    type="button"
                    onClick={handleExport}
                    className="mr-2 inline-flex active:text-white items-center justify-center rounded-md border border-transparent hover:text-white btn-green px-3 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                  >
                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                    Export CSV
                  </button>
                </div>
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex">
                    <div className=" relative rounded-md shadow-sm ml-3">
                      <p className='text-sm leading-3 text-gray-500'>From</p>
                      <div>
                        <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                      </div>
                    </div>
                    <div className=" relative rounded-md shadow-sm ml-3">
                      <p className='text-sm leading-3 text-gray-500'>To</p>
                      <div>
                        <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                      </div>
                    </div>
                    <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                      </div>
                      <input
                        type="text"
                        name="search"
                        id="search"
                        onChange={(e) => searchAccount(e.target.value)}
                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                        placeholder="Search account"
                      />
                    </div>
                    <div className='mt-5 ml-3'>
                      <button
                        onClick={range}
                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                    </div>
                  </div>
                </div>
                <div className='sm:flex-auto flex'>
                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                      <select
                        id="accountOpeningMedium"
                        name="accountOpeningMedium"
                        onChange={(e) => handleMedium(e.target.value)}
                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full  pl-2  border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                      >
                        <option value={"All"}>Filter by medium</option>
                        <option value={"NIN"}>NIN</option>
                        <option value={"BVN"}>BVN</option>
                      </select>
                    </div>
                </div>
                {accounts.length === 0 ?
                  (
                    <div className=" mt-8"> No data available for these dates to show. </div>
                  ) :
                  <>
                    <div className="mt-8 flex ">
                      <div className="-my-2  overflow-x-auto ">
                        <div className="inline-block min-w-full py-2 align-middle">
                          <div className="relative   ring-black ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                              <thead>
                                <tr>
                                  <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                    Surname
                                  </th>
                                  <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                    First Name
                                  </th>
                                  <th scope="col" className="min-w-[8rem] py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    BVN
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    NIN
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Phone Number
                                  </th>
                                  <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Email
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Medium
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Stage
                                  </th>
                                  {/* <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Status
                                  </th> */}
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Account Number
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Customer Number
                                  </th>
                                  <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                    Date Created
                                  </th>
                                  <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                    <span className="sr-only">Edit</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {accounts.slice().reverse().map((person, i) => (
                                  <tr key={i} className="bg-gray-50">
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.surname}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.firstName}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.bvn}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.nin}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.phoneNumber}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.emailAddress}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountOpeningMedium}</td>
                                    <td>
                                      <span className={classNames(
                                        stageStyles[person.accountOpeningStage] || 'bg-gray-100 text-gray-800', "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium")}>{person.accountOpeningStage || "N/A"}</span>
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountNumber}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.customerNumber}</td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.createdOn)}</td>
                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" value={person.id}>
                                      <ActionDropdown
                                        items={[
                                          { label: "View Account", onClick: () => window.location.href = `/view/online-account?id=${person.id}` },
                                        ]}
                                        dropdownWidth="w-40"
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Paginate
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        totalCount={pageNumber}
                        totalPages={totalPage}
                        prevPage={prevPage}
                        setPageIndex={setPageIndex}
                    />
                  </>}

              </div>

            </div>
          </div>
        </main>

      </React.Fragment>
    </Layout>



  </>);
}
